import React from 'react';
import styled from 'styled-components';
import Icon from 'js/components/common/Icon';
import { primaryColor } from 'js/config/style';

const Container = styled.div`
  text-align: center;
  margin-bottom: 1rem;
`;

const HouseIcon = styled(Icon).attrs({ name: 'home' })`
  font-size: 3rem;
  color: ${primaryColor};
`;

export default () => (
  <Container>
    <HouseIcon />
  </Container>
);
